<div
  class="flex min-w-[158px] flex-1 flex-col gap-2 rounded-lg p-6 border border-[#d0dee7] bg-white"
  [class.ring-1]="highlight"
  [class.ring-[#e7eef3]]="highlight"
  [class.cursor-pointer]="clickable"
  [attr.role]="clickable ? 'button' : 'group'"
  tabindex="{{ clickable ? 0 : -1 }}"
  (click)="onClick()"
  (keydown.enter)="onClick()"
>
  <div class="flex items-center gap-2">
    @if (iconSafe) {
      <div class="text-[#0e161b]" aria-hidden="true" [innerHTML]="iconSafe"></div>
    }
    <p class="text-[#0e161b] text-base font-medium leading-normal truncate">{{ title }}</p>
  </div>

  @if (!loading) {
    <p class="text-[#0e161b] tracking-light text-2xl font-bold leading-tight break-words">
      {{ formattedValue }}
    </p>
  } @else {
    <div class="h-7 w-32 rounded bg-slate-200 animate-pulse"></div>
  }

  @if (subtext) {
    <p class="text-[#4e7a97] text-xs leading-normal">{{ subtext }}</p>
  }
</div>